__turbopack_context__.v({
  "container": "search-feedback-module__2XlcHW__container",
  "emojiButton": "search-feedback-module__2XlcHW__emojiButton",
  "emojiContainer": "search-feedback-module__2XlcHW__emojiContainer",
  "eye": "search-feedback-module__2XlcHW__eye",
  "eyeLeft": "search-feedback-module__2XlcHW__eyeLeft",
  "eyeRight": "search-feedback-module__2XlcHW__eyeRight",
  "fadeOut": "search-feedback-module__2XlcHW__fadeOut",
  "feedbackBox": "search-feedback-module__2XlcHW__feedbackBox",
  "frownContainer": "search-feedback-module__2XlcHW__frownContainer",
  "promptText": "search-feedback-module__2XlcHW__promptText",
  "smileContainer": "search-feedback-module__2XlcHW__smileContainer",
  "thanksText": "search-feedback-module__2XlcHW__thanksText",
});
